import React, {useState, useEffect} from 'react';
import apiInstance from '../../utils/axios';
import UserData from '../plugin/UserData';
import { Link } from 'react-router-dom';
import Slidebar from './Slidebar';
import Swal from 'sweetalert2';
import PriceFormat_Basic from '../../components/commerce-ui/price-format-basic';

function Wishlist() {
    const [wishlist, setWishlist] = useState([]);
    const [loading, setLoading] = useState(true);

    const userData = UserData();

    const fetchWishlist = async () => {
        if (!userData?.user_id) return;
        
        try {
            setLoading(true);
            const response = await apiInstance.get(`customer/wishlist/${userData.user_id}/`);
            setWishlist(response.data);
        } catch (error) {
            console.error('Error fetching wishlist:', error);
            setWishlist([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchWishlist();
    }, [userData?.user_id]);

    const toggleWishlist = async (productId) => {
        if (!userData?.user_id) {
            Swal.fire({
                title: "Por favor, inicia sesión para gestionar tu lista de deseos",
                icon: 'warning',
                confirmButtonText: "Aceptar"
            });
            return;
        }

        try {
            const formData = new FormData();
            formData.append("product_id", productId);
            formData.append("user_id", userData.user_id);

            const response = await apiInstance.post(`customer/wishlist/${userData.user_id}/`, formData);
            
            // Refresh wishlist after toggle
            await fetchWishlist();

            Swal.fire({
                title: response.data.message,
                icon: 'success',
                confirmButtonText: "Aceptar"
            });
        } catch (error) {
            console.error('Error toggling wishlist:', error);
            Swal.fire({
                title: "Error al actualizar la lista de deseos",
                icon: 'error',
                confirmButtonText: "Aceptar"
            });
        }
    };

    if (!userData?.user_id) {
        return (
            <div>
                <main className="mt-5">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-md-8 text-center">
                                <div className="card">
                                    <div className="card-body p-5">
                                        <i className="fas fa-heart text-danger fa-3x mb-3"></i>
                                        <h3>Inicio de Sesión Requerido</h3>
                                        <p className="text-muted">Por favor, inicia sesión para ver tu lista de deseos</p>
                                        <Link to="/login/" className="btn btn-primary">
                                            Iniciar Sesión
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        );
    }

    return (
        <div>
            <main className="mt-5">
                <div className="container">
                    <section className="">
                        <div className="row">
                            <Slidebar />

                            <div className="col-lg-9 mt-1">
                                <section className="">
                                    <main className="mb-5">
                                        <div className="container">
                                            <section className="">
                                                <div className="row">
                                                    <h3 className="mb-3">
                                                        <i className="fas fa-heart text-danger me-2" /> 
                                                        Lista de Deseos
                                                    </h3>
                                                    
                                                    {loading ? (
                                                        <div className="col-12 text-center">
                                                            <div className="spinner-border text-primary" role="status">
                                                                <span className="visually-hidden">Cargando...</span>
                                                            </div>
                                                        </div>
                                                    ) : wishlist && wishlist.length > 0 ? (
                                                        wishlist.map((w, index) => (
                                                            <div className="col-lg-4 col-md-6 mb-4" key={w.id || index}>
                                                                <div className="card h-100">
                                                                    <div className="bg-image hover-zoom ripple">
                                                                        <Link to={`/detail/${w.product.slug}/`} className="text-decoration-none">
                                                                            <img
                                                                                src={w.product.image}
                                                                                className="w-100"
                                                                                style={{height: '250px', objectFit: "cover"}}
                                                                                alt={w.product.title_translated || w.product.title}
                                                                            />
                                                                        </Link>
                                                                    </div>
                                                                    <div className="card-body d-flex flex-column">
                                                                        <Link to={`/detail/${w.product.slug}/`} className="text-reset text-decoration-none">
                                                                            <h5 className="card-title mb-2">{w.product.title_translated || w.product.title}</h5>
                                                                        </Link>
                                                                        
                                                                        {w.product.category && (
                                                                            <Link to={`/products?category=${w.product.category.id}`} className="text-reset text-decoration-none">
                                                                                <p className="text-muted small mb-2">{w.product.category.title_translated || w.product.category.title}</p>
                                                                            </Link>
                                                                        )}

                                                                        <div className="d-flex align-items-center mb-3">
                                                                            <PriceFormat_Basic value={w.product.price} className="mb-0 fw-bold text-primary" />
                                                                            {w.product.old_price && w.product.old_price > w.product.price && (
                                                                                <PriceFormat_Basic value={w.product.old_price} className="mb-0 text-muted ms-2 text-decoration-line-through" />
                                                                            )}
                                                                        </div>
                                                                        
                                                                        <div className="mt-auto">
                                                                            <button
                                                                                onClick={() => toggleWishlist(w.product.id)}
                                                                                type="button"
                                                                                className="btn btn-outline-danger w-100"
                                                                                title="Remover de la lista de deseos"
                                                                            >
                                                                                <i className="fas fa-heart me-2" />
                                                                                Remover
                                                                            </button>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))
                                                    ) : (
                                                        <div className="col-12 text-center">
                                                            <div className="card">
                                                                <div className="card-body p-5">
                                                                    <i className="fas fa-heart text-muted fa-3x mb-3"></i>
                                                                    <h4 className="text-muted">Tu lista de deseos está vacía</h4>
                                                                    <p className="text-muted">Comienza a agregar productos que te gusten</p>
                                                                    <Link to="/products/" className="btn btn-primary">
                                                                        Explorar Productos
                                                                    </Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </section>
                                        </div>
                                    </main>
                                </section>
                            </div>
                        </div>
                    </section>
                </div>
            </main>
        </div>
    );
}

export default Wishlist;